import axios from "axios";
import API_ROUTES from "../../../../config/api";

const createOrganisation = async (state) => {
  if (state.store?.company_id) {
    return state.store.company_id;
  }

  const organisationResponse = await axios.put(API_ROUTES.onboarding['application:create'](), {
    name: state.data.company_details.organisation_name,
    website: state.data.company_details.website_url,
    address: state.data.company_information.address_1,
    address2: state.data.company_information.address_2,
    companies_house_number: state.data.company_information.companies_house_number,
    country: state.data.company_information.country,
    city: state.data.company_information.locality,
    zip: state.data.company_information.postal_code,
    vat_number: state.data.company_information.vat_number,
  });

  return organisationResponse.data.data.id;
};

export default createOrganisation;
